import Modal from "flarum/components/Modal";
import { urls } from "@speareducation/util";

export default class NotAuthModal extends Modal {
  className() {
    return "NotAuthModal";
  }

  title() {
    return "You do not have access to Spear Talk";
  }

  content() {
    return (
      <div className="Modal-body not-auth-body">
        <p>Membership allows you to:</p>
        <ul>
          <li>
            Connect with thousands of doctors, team members, and Spear Faculty
          </li>
          <li>Engage with a variety of clinical and practice topics</li>
          <li>Ask questions and share cases for feedback</li>
          <li>Access guidance on-the-go with our mobile app</li>
        </ul>

        <div className="upgrade-btn">
            <a
              href={`${urls.getBaseUrl("www")}/spear-dental-ce-membership-benefits`}
              className="Button Button--primary"
            >
              Upgrade your Membership
            </a>
        </div>
      </div>
    );
  }
}
